import React, { useState } from 'react';

import { Logo } from './../Logo/Logo';
import burguerMenu from './menu.png';

import './styles.css';

export const Header = () => {
    const [showMenu, setShow] = useState(false);

    const menuItems = 
        <div className={`menu-items ${showMenu ? '' : 'hide'}`}>
            <a href="">INICIO</a>
            <a href="#nuestra-marca">NUESTRA MARCA</a>
            <a href="#caracteristicas">CARACTERÍSTICAS</a>
            <a href="#productos">PRODUCTOS</a>
            <a href="#contacto">CONTACTO</a>
        </div>;

    return (
        <header>
            <div className="container">
                <Logo/>
                <img alt="" src={burguerMenu} onClick={() => setShow(!showMenu)}/>
            </div>
            {menuItems}
        </header>
    )
};